import { Poptip } from "@optimizely/axiom";
import React from "react";
import { UserArrowRight } from "../SVGIcons/UserArrowRight";
import classnames from "classnames";

export const ExternalUserIndicator = ({ className = "", fill }: { className?: string; fill?: string }) => {
    const classes = classnames("external-icon", className);
    return (
        <Poptip content="External User" position="top" isInline={true} className="" trigger="mouseenter">
            <span className={classes}>
                <UserArrowRight fill={fill} />
            </span>
        </Poptip>
    );
};

ExternalUserIndicator.displayName = "ExternalUserIndicator";
